<div class="padding flex column fix-width">
	<b>Shooting in progress</b>
	<img class="pickup-image margin-bottom-small margin-top-small" src="assets/progress.png" alt="Pickup ready" />

	<div class="bg-orange padding-small margin-bottom-small">
		<i class="fa-solid fa-hourglass margin-right-smallest"></i>
		Shooting is in progress!
	</div>

	<div>Data editing is not available till shooting is completed.</div>

	<div class="flex column end full-width margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked">
				<i class="fa-solid fa-check"></i>
				Close
			</button>
		</div>
	</div>
</div>
